module.exports = __webpack_public_path__ + "img/section5_img1_5.8e656b7e.png";